import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import Switch from '@/components/Switch';
import { CHECKOUT_PAGE_OPTION } from '@/constants/enum';
import { IMAGE } from '@/helpers/link';
import { StyledPadding } from '@/pages/GeneralSetting/styled';
import { generalSettingSelector, handleSaveSettings } from '@/redux/slice/setting.slice';
import { Badge, BlockStack, Box, Card, Icon, InlineStack } from '@shopify/polaris';
import { PageReferenceIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ViewDemoModal } from './ViewDemoModal';

export const CheckoutPage = () => {
  const { t } = useTranslation('general_settings');
  const generalSettings = useSelector(generalSettingSelector);
  const dispatch = useDispatch();
  const [modal, setModal] = useState({
    isOpenViewDemoProduct: false,
    isOpenViewDemoCart: false,
  });
  return (
    <Card>
      <BlockStack gap={'300'}>
        <Box>
          <InlineStack gap={'200'}>
            <Box>
              <Icon source={PageReferenceIcon} />
            </Box>
            <InlineStack gap="200" blockAlign="center">
              <BoldText>{t('sections.advancedSetting.checkoutPage.title')}</BoldText>
              <Badge tone="info">{t('sections.advancedSetting.checkoutPage.betaFeature')}</Badge>
            </InlineStack>
          </InlineStack>
          <StyledPadding paddingLeft="28px">
            <Box color="text-secondary">{t('sections.advancedSetting.checkoutPage.helpText')}</Box>
          </StyledPadding>
        </Box>
        <Card>
          <BlockStack gap={'100'}>
            <InlineStack blockAlign="center" align="space-between" gap={'150'}>
              <RegularText fontWeight="medium">{t('sections.advancedSetting.checkoutPage.noneLabel')}</RegularText>
              <Switch
                isActive={generalSettings.isChangeMethodShipping !== CHECKOUT_PAGE_OPTION.OFF}
                onSwitch={() =>
                  dispatch(
                    handleSaveSettings({
                      isChangeMethodShipping:
                        generalSettings.isChangeMethodShipping !== CHECKOUT_PAGE_OPTION.OFF
                          ? CHECKOUT_PAGE_OPTION.OFF
                          : CHECKOUT_PAGE_OPTION.ON,
                    }),
                  )
                }
              />
            </InlineStack>
            <RegularText>{t('sections.advancedSetting.checkoutPage.noneHelpText')}</RegularText>
          </BlockStack>
        </Card>
      </BlockStack>
      <ViewDemoModal
        open={modal.isOpenViewDemoProduct}
        onClose={() => setModal({ ...modal, isOpenViewDemoProduct: false })}
        imgSrc={IMAGE.DEMO_PRODUCT_PAGE_IMG}
        size="large"
      />
      <ViewDemoModal
        open={modal.isOpenViewDemoCart}
        onClose={() => setModal({ ...modal, isOpenViewDemoCart: false })}
        imgSrc={IMAGE.DEMO_CART_PAGE_IMG}
        size="large"
      />
    </Card>
  );
};
